/* LUXE motion controller (site-redesign-2026 Phase 0)
   Spec: DESIGN-SYSTEM.md §7. One IntersectionObserver for reveals,
   stagger groups and count-ups. No dependencies, defer-loaded.
   Reduced motion: reveals handled by CSS; count-ups print final values. */
(function () {
  'use strict';
  var rmq = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* A count-up target must carry a NUMERIC data-luxe-count. An empty or
     non-numeric attribute (e.g. the collection toolkit's old bare
     data-luxe-count) is not a stat and must never be zeroed to "0". */
  function isCount(el) {
    var raw = el.getAttribute('data-luxe-count');
    return raw !== null && raw.trim() !== '' && !isNaN(parseInt(raw, 10));
  }

  /* Count-up: <el data-luxe-count="48000" data-luxe-suffix="+"> */
  function printFinal(el) {
    var n = parseInt(el.getAttribute('data-luxe-count'), 10) || 0;
    el.textContent = n.toLocaleString('en-GB') + (el.getAttribute('data-luxe-suffix') || '');
  }
  function countUp(el) {
    if (rmq.matches) return printFinal(el);
    var n = parseInt(el.getAttribute('data-luxe-count'), 10) || 0;
    var suffix = el.getAttribute('data-luxe-suffix') || '';
    var t0 = performance.now();
    (function tick(t) {
      var p = Math.min((t - t0) / 1200, 1);
      el.textContent = Math.round(n * (1 - Math.pow(1 - p, 3))).toLocaleString('en-GB') + suffix;
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }

  function init() {
    var counts = [].filter.call(document.querySelectorAll('[data-luxe-count]'), isCount);
    if (rmq.matches) counts.forEach(printFinal);

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.luxe-reveal,.luxe-reveal-group').forEach(function (el) {
        el.classList.add('in');
      });
      counts.forEach(printFinal);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        if (isCount(e.target) && !rmq.matches) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.luxe-reveal,.luxe-reveal-group,[data-luxe-count]').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
